<div
  class="dock"
  [class.dock--docked]="effectiveMode() === 'docked'"
  [class.dock--floating]="effectiveMode() === 'floating'"
  [class.dock--fullscreen]="effectiveMode() === 'fullscreen'"
>
  <div class="dock__content">
    <ng-content />
  </div>

  @if (dock.component(); as component) {
    <section
      class="dock__panel"
      [class.dock__panel--hidden]="!visible()"
      role="complementary"
      [attr.aria-label]="'AI_ASSISTANT.DOCK.LABEL' | translate"
      [attr.aria-hidden]="!visible() ? 'true' : null"
    >
      <header class="dock__header">
        @if (!isMobile()) {
          <button
            mat-icon-button
            [matMenuTriggerFor]="modeMenu"
            [attr.aria-label]="'AI_ASSISTANT.DOCK.SWITCH_MODE' | translate"
          >
            <mat-icon>view_sidebar</mat-icon>
          </button>
        }
        <button mat-icon-button [attr.aria-label]="'AI_ASSISTANT.SHARED.CLOSE' | translate" (click)="dock.hide()">
          <mat-icon>close</mat-icon>
        </button>
      </header>
      <div class="dock__body">
        <ng-container *ngComponentOutlet="component; inputs: dock.inputs()" />
      </div>
    </section>
  }
</div>

<mat-menu #modeMenu="matMenu" class="ai-dock-mode-menu">
  <div class="dock__menu-label">{{ 'AI_ASSISTANT.DOCK.SWITCH_TO' | translate }}</div>
  <button mat-menu-item (click)="dock.setMode('floating')">
    <mat-icon>picture_in_picture_alt</mat-icon>
    <span>{{ 'AI_ASSISTANT.DOCK.MODE_FLOATING' | translate }}</span>
    @if (dock.mode() === 'floating') {
      <mat-icon class="dock__menu-check">check</mat-icon>
    }
  </button>
  <button mat-menu-item (click)="dock.setMode('docked')">
    <mat-icon>view_sidebar</mat-icon>
    <span>{{ 'AI_ASSISTANT.DOCK.MODE_SIDEBAR' | translate }}</span>
    @if (dock.mode() === 'docked') {
      <mat-icon class="dock__menu-check">check</mat-icon>
    }
  </button>
  <button mat-menu-item (click)="dock.setMode('fullscreen')">
    <mat-icon>fullscreen</mat-icon>
    <span>{{ 'AI_ASSISTANT.DOCK.MODE_FULLSCREEN' | translate }}</span>
    @if (dock.mode() === 'fullscreen') {
      <mat-icon class="dock__menu-check">check</mat-icon>
    }
  </button>
</mat-menu>
